import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Layout } from '@/components/layout/Layout';
import { CompanyDirectoryCore } from '@/components/companies/CompanyDirectoryCore';
import { Button } from '@/components/ui/button';
import { Building2, Handshake, Shield, TrendingUp, ArrowRight } from 'lucide-react';

export default function SuppliersHub() {
  const { t } = useTranslation();

  return (
    <Layout>
      {/* Hero section */}
      <div className="border-b bg-secondary/5">
        <div className="container py-10 md:py-14">
          <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
            <div className="max-w-2xl">
              <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-secondary/30 bg-secondary/10 px-3 py-1 text-sm font-medium text-secondary">
                <Building2 className="h-3.5 w-3.5" />
                {t('suppliers.badge')}
              </div>
              <h1 className="text-3xl font-bold md:text-4xl">{t('suppliers.hero.title')}</h1>
              <p className="mt-3 text-lg text-muted-foreground">{t('suppliers.hero.subtitle')}</p>
            </div>
            <div className="flex shrink-0 gap-3">
              <Button asChild>
                <Link to="/auth?mode=signup&role=company&type=congolese_sme">
                  {t('suppliers.hero.listBusiness')}
                  <ArrowRight className="ml-1 h-4 w-4" />
                </Link>
              </Button>
            </div>
          </div>

          {/* Value props */}
          <div className="mt-8 grid gap-4 sm:grid-cols-3">
            <div className="flex items-start gap-3 rounded-lg border border-border/50 bg-background p-4">
              <Handshake className="mt-0.5 h-5 w-5 shrink-0 text-secondary" />
              <div>
                <p className="text-sm font-semibold">{t('suppliers.valueProps.contracts.title')}</p>
                <p className="text-xs text-muted-foreground">{t('suppliers.valueProps.contracts.desc')}</p>
              </div>
            </div>
            <div className="flex items-start gap-3 rounded-lg border border-border/50 bg-background p-4">
              <Shield className="mt-0.5 h-5 w-5 shrink-0 text-secondary" />
              <div>
                <p className="text-sm font-semibold">{t('suppliers.valueProps.verified.title')}</p>
                <p className="text-xs text-muted-foreground">{t('suppliers.valueProps.verified.desc')}</p>
              </div>
            </div>
            <div className="flex items-start gap-3 rounded-lg border border-border/50 bg-background p-4">
              <TrendingUp className="mt-0.5 h-5 w-5 shrink-0 text-secondary" />
              <div>
                <p className="text-sm font-semibold">{t('suppliers.valueProps.growth.title')}</p>
                <p className="text-xs text-muted-foreground">{t('suppliers.valueProps.growth.desc')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Directory with locked filter */}
      <div className="container py-8">
        <CompanyDirectoryCore
          lockedTypeFilters={['congolese_sme']}
          hideTypeFilter
          ctaLabel={t('suppliers.viewProfile')}
          emptyMessage={t('suppliers.noResults')}
        />
      </div>
    </Layout>
  );
}
